/* eslint-disable custom-eslint-rules/force-logicalOperandsMustBeBoolean */
import styled from "styled-components";
import { ICONSAX_SIZE } from "../Iconsax/Iconsax.types.js";
import { ITheme } from "../Theme/Theme.types.js";
import { TagV2Colors, TagV2Props } from "./TagV2.types.js";

export const getTagBackground = (color: TagV2Colors | undefined, theme: ITheme): string => {
    if (!color) return theme.colors.primary[100];
    if (color === "black") return theme.grayscale[100];
    if (color === "gray") return theme.grayscale[90];
    if (color === "yellow") return theme.colors.yellow[110];
    if (color === "gradient") return theme.gradients.newPurpleToGreen;
    if (color === "gradiantBlackThirstday") return theme.gradients.blackThirstday;

    const themeColor = theme?.colors?.[color];
    return themeColor?.[100] ?? theme.colors.primary[100];
};

export const TextWrapper = styled.div`
    overflow: hidden;
`;

export const IconWrapper = styled.div<{ visible: boolean }>`
    display: inline-flex;
    align-items: center;
    overflow: hidden;
    opacity: ${({ visible }) => (visible ? 1 : 0)};
    max-width: ${({ visible, theme }) => (visible ? `calc(${ICONSAX_SIZE.SMALL}px + ${theme.spacing["4"]} * 2)` : "0")};
    margin-left: ${({ visible, theme }) => (visible ? "0" : `-${theme.spacing["4"]}`)};
    transition:
        opacity 150ms ease-in-out,
        max-width 150ms ease-in-out,
        margin-left 150ms ease-in-out;
    pointer-events: ${({ visible }) => (visible ? "auto" : "none")};
`;

export const StyledTag = styled.div<TagV2Props>`
    padding: ${(props) =>
        `${props.theme.spacing["4"]} ${props.showIcon ? props.theme.spacing["4"] : props.theme.spacing["8"]} ${props.theme.spacing["4"]} ${
            props.theme.spacing["8"]
        }`};
    border-radius: ${(props) => props.theme.radius.xxs};
    color: ${(props) => props.theme.grayscale.white};
    background: ${(props) => getTagBackground(props.color, props.theme)};
    cursor: default;
    display: inline-flex;
    height: 20px;
    justify-content: center;
    align-items: center;
    gap: ${(props) => props.theme.spacing["4"]};
    max-width: ${({ maxWidth }) => maxWidth || "144px"};
    flex-shrink: 0;
    cursor: ${(props) => (props.onClick ? "pointer" : "default")};
`;
